import { Card } from '@/components/Card';
import { cls } from '@/utils/cls';

type Props = {
  containerClass?: string;
  iconClass?: string;
  message?: string;
};

export function Loader({ containerClass = '', iconClass, message }: Props) {
  const cardClass = cls(containerClass, 'flex flex-col justify-center items-center');
  const spinClass = cls(
    'animate-spin inline-block border-current border-t-transparent rounded-full text-[#274483] size-16 border-6',
    iconClass ? iconClass : '',
  );
  const copy = message ? <h4 className="pt-12 pb-6 px-6">{message}</h4> : null;

  return (
    <Card className={cardClass}>
      <div className={spinClass} role="status" aria-label="loading">
        <span className="sr-only">{message ?? 'Loading...'}</span>
      </div>
      {copy}
    </Card>
  );
}
